import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const accountGroupCommission = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/group-commission',
  component: lazyRouteComponent(
    () => import('@/pages/account-group-commission/account-group-commission-page'),
  ),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const detailAccountGroupCommission = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/group-commission/$id',
  component: lazyRouteComponent(
    () => import('@/pages/account-group-commission/account-group-commission-detail'),
  ),
});
